import { Link } from "react-router-dom";
import HeaderBis from "../components/layout/headerbis";
import backgroundImage from "../assets/img/accessoires.webp";
import PompeChaleur from "../assets/img/pompechaleur.webp"; 
import Aspirateur from "../assets/img/aspirateur.webp";
import SPA from "../assets/img/doseur.webp";
import FauteuilBASIC from "../assets/img/fauteuil.webp";
import Badesofa from "../assets/img/badesofa.webp";
import Tablette from "../assets/img/tablette.webp";
import Coffre from "../assets/img/coffre.webp";
import Doseur from "../assets/img/doseur.webp";
import Thermometre from "../assets/img/thermometre.webp";
import Paroi from "../assets/img/traverséedeparoie.webp";
import Filtre from "../assets/img/massefiltrante.webp";
import GroupeFiltrant from "../assets/img/pompe.webp";
import PorteVitre from "../assets/img/vitres.webp";
import Poele1 from "../assets/img/poele1.webp";
import Poele2 from "../assets/img/poele2.webp";
import Couverture from "../assets/img/couverclethermo.webp";
import Couvercle from "../assets/img/couverclebois.webp";

export const accessoriesData = [
  { name: "Pompe à Chaleur Reversible 3kw", url: "pompe-chaleur", image: PompeChaleur, price: "€", description: "Garantie 2 ans. Optimisez le chauffage et le refroidissement de votre Tank pool. Compacte et polyvalente, cette pompe à chaleur 3 kW permet jusqu’à 75 % d’économie d’énergie par rapport à un réchauffeur électrique classique. Conçue pour tout type de Tank pool, elle intègre une fonction chiller, abaissant la température jusqu’à 3°C pour une expérience de bain rafraîchissante. Son contrôle WiFi offre un pilotage à distance, tandis que son serpentin en titane assure une résistance optimale à la corrosion. Adaptée aux climats chauds et tempérés, elle s’installe facilement grâce à son système Plug & Play, compatible avec un réchauffeur existant. Profitez d’un confort thermique sur-mesure, été comme hiver, et découvrez les bienfaits du froid pour la récupération musculaire et la détente — l’innovation au service du bien-être." },
  { name: "Pompe à Chaleur Reversible 5kw", url: "pompe-chaleur", image: PompeChaleur, price: "€", description: "Garantie 2 ans. Optimisez le chauffage et le refroidissement de votre Tank pool. Compacte et polyvalente, cette pompe à chaleur 5 kW permet jusqu’à 75 % d’économie d’énergie par rapport à un réchauffeur électrique classique. Conçue pour tout type de Tank pool, elle intègre une fonction chiller, abaissant la température jusqu’à 3°C pour une expérience de bain rafraîchissante. Son contrôle WiFi offre un pilotage à distance, tandis que son serpentin en titane assure une résistance optimale à la corrosion. Adaptée aux climats chauds et tempérés, elle s’installe facilement grâce à son système Plug & Play, compatible avec un réchauffeur existant. Profitez d’un confort thermique sur-mesure, été comme hiver, et découvrez les bienfaits du froid pour la récupération musculaire et la détente — l’innovation au service du bien-être." },
  { name: "Pompe à Chaleur Reversible 7kw", url: "pompe-chaleur", image: PompeChaleur, price: "€", description: "Garantie 2 ans. Optimisez le chauffage et le refroidissement de votre Tank pool. Compacte et polyvalente, cette pompe à chaleur 7 kW permet jusqu’à 75 % d’économie d’énergie par rapport à un réchauffeur électrique classique. Conçue pour tout type de Tank pool, elle intègre une fonction chiller, abaissant la température jusqu’à 3°C pour une expérience de bain rafraîchissante. Son contrôle WiFi offre un pilotage à distance, tandis que son serpentin en titane assure une résistance optimale à la corrosion. Adaptée aux climats chauds et tempérés, elle s’installe facilement grâce à son système Plug & Play, compatible avec un réchauffeur existant. Profitez d’un confort thermique sur-mesure, été comme hiver, et découvrez les bienfaits du froid pour la récupération musculaire et la détente — l’innovation au service du bien-être." },
  { name: "Aspirateur sans fil", url: "aspirateur-sans-fil", image: Aspirateur, price: "99 €", description: "Aspirateur pratique et sans fil." },
  //{ name: "KIT JACCUZI", url: "kit-jaccuzi", image: SPA, price: "490 €", description: "Kit complet JACCUZI pour mini-piscine. 4 jets Air/Eau + Pompe de massage." },
  { name: "Fauteuil immergé BASIC", url: "fauteuil-immerge-basic", image: FauteuilBASIC, price: "190 €", description: "Fauteuil pour bain immergé." },
  { name: "Coussin BadeSofa pour le dos", url: "coussin-badesofa", image: Badesofa, price: "219 €", description: "Coussin pour confort du dos." },
  { name: "Tablette en Bois", url: "tablette-bois", image: Tablette, price: "45 €", description: "Tablette en bois pour mini-piscine." },
  { name: "Coffre Bois", url: "coffre-bois", image: Coffre, price: "290 €", description: "Coffre en bois pour rangement." },
  { name: "Doseur flottant diffuseur de chlore", url: "doseur-chlore", image: Doseur, price: "4.90 €", description: "Diffuseur flottant pour chlore." },
  { name: "Thermomètre de piscine", url: "thermometre", image: Thermometre, price: "6 €", description: "Thermomètre précis pour piscine." },
  { name: "Traversée de paroi Aspiration/ refoulement", url: "traversee-paroi", image: Paroi, price: "50 €", description: "Traversée de paroi pour filtration." },
  { name: "Média Filtrant PUREFLOW pour filtre à sable", url: "media-filtrant", image: Filtre, price: "30 €", description: "Média filtrant pour filtration." },
  { name: "GROUPE DE FILTRATION", url: "groupe-filtration", image: GroupeFiltrant, price: "149 €", description: "Groupe complet pour filtration." },
  { name: "Porte vitrée Poêle à bois pour modèle Round 39Kw", url: "porte-vitre-poele", image: PorteVitre, price: "70 €", description: "Porte vitrée pour poêle Round." },
  { name: "Poêle à bois FireBox 22 kW Certifié CE", url: "poele-firebox", image: Poele1, price: "940 €", description: "Poêle à bois 22kW compact et performant, conçu pour une chauffe efficace. Dimensions : 570 mm de hauteur, 504 mm de profondeur et 371 mm de largeur. Livré avec cheminée (2 x 1 m + chapeau). Poids : 31 kg. Compatible avec des bûches jusqu’à 475 mm." },
  { name: "Poêle à bois Round 39 KW Certifié CE", url: "poele-round", image: Poele2, price: "1 240 €", description: "Poêle à bois 39kW compact et performant, conçu pour une chauffe efficace. Dimensions : 640 mm de hauteur, 625 mm de profondeur et 550 mm de largeur. Livré avec cheminée (2 x 1 m + chapeau). Poids : 42 kg. Compatible avec des bûches jusqu’à 550 mm." },

  {
    name: "Couverture thermique Rond",
    url: "couverture-rond",
    image: Couverture,
    variants: {
      tailles: [
        { taille: "244", prix: "890 €" },
        { taille: "213", prix: "750 €" },
        { taille: "183", prix: "650 €" },
        { taille: "152", prix: "550 €" },
        { taille: "122", prix: "360 €" },
      ],
    },
  },
  {
    name: "Couverture thermique Ovale",
    url: "couverture-ovale",
    image: Couverture,
    variants: {
      tailles: [
        { taille: "244", prix: "530 €" },
        { taille: "213", prix: "390 €" },
        { taille: "183", prix: "350 €" },
        { taille: "152", prix: "225 €" },
        { taille: "122", prix: "180 €" },
        { taille: "91", prix: "135 €" },
      ],
    },
  },

  {
    name: "Couvercle Bois Triply Rond",
    url: "couvercle-rond",
    image: Couvercle,
    variants: {
      tailles: [
        { taille: "244", prix: "550 €" },
        { taille: "213", prix: "550 €" },
        { taille: "183", prix: "550 €" },
        { taille: "152", prix: "550 €" },
      ],
    },
  },
  {
    name: "Couvercle Bois Triply Ovale",
    url: "couvercle-ovale",
    image: Couvercle,
    variants: {
      tailles: [
        { taille: "244", prix: "400 €" },
        { taille: "213", prix: "400 €" },
        { taille: "183", prix: "400 €" },
        { taille: "152", prix: "400 €" },
      ],
    },
  },
];

export default function AccessoriesPage() {
  return (
    <div>
      <HeaderBis
        backgroundImage={backgroundImage}
        title="ACCESSOIRES"
        desc="Tous nos accessoires pour mini-piscines"
      />
      <div className="container mx-auto pt-20 pb-20 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {accessoriesData.map((item) => (
            <div
              key={item.url}
              className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition"
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-44 object-cover"
              />
              <div className="p-4 flex flex-col items-center text-center">
                <h2 className="text-lg font-semibold mb-1">{item.name}</h2>
                <p className="text-gray-700 mb-2">{item.price}</p>
                <Link
                  to={`/accessoire/${encodeURIComponent(item.url)}`}
                  className="w-36 mt-2 flex items-center justify-center bg-[#005478] border border-[#005478] text-white py-2 rounded-full hover:bg-[#ffffff] hover:text-[#005478] transition"
                >
                  Voir le produit
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
